<app-aggregated-amount-item name="UM ホームページユーザー数"
  icon="./assets/universal_music.png"
  amount="{{ (umhpPageUserview$ | async)?.units }}"
  unit="ページユーザー数"
  [rate]="(umhpPageUserview$ | async)?.rate"
  [link]="(selectedArtist$ | async)?.umhpUrl"
  [hasAmount]="(umhpPageUserview$ | async)?.hasUnits"
  help="{{
    (selectedArtist$ | async)?.nameMain
  }} のページユーザー数です。ページユーザー数は選択期間内の合計数です。"
  [loading]="loading$ | async"
  [dataCollections]="dataCollections$ | async"
  [dataCollectLoading]="dataCollectLoading$ | async">
</app-aggregated-amount-item>